import canonicalPath from 'utils/canonicalPath'

const CANONICAL_DOMAIN =
  process.env.REACT_APP_CANONICAL_DOMAIN || 'https://www.supersummary.com'

export default location => CANONICAL_DOMAIN + canonicalPath(location)
